module.exports = __webpack_public_path__ + "img/pt.4cb5639c.png";